import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import IndustriesPage from "../pages/industries/page";
import TechnologiesPage from "../pages/technologies/page";
import TalentPage from "../pages/talent/page";
import HowItWorksPage from "../pages/how-it-works/page";
import CaseStudiesPage from "../pages/case-studies/page";
import CareersPage from "../pages/careers/page";
import FAQPage from "../pages/faq/page";
import TrustSecurityPage from "../pages/trust-security/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import PricingPage from "../pages/pricing/page";
import BlogPage from "../pages/blog/page";
import LeadershipPage from "../pages/leadership/page";
import SoftwareDevelopmentPage from "../pages/landing/software-development/page";
import TalentSolutionsPage from "../pages/landing/talent-solutions/page";
import HireReactDevelopersPage from "../pages/landing/hire-react-developers/page";
import OffshoreTeamIndiaPage from "../pages/landing/offshore-team-india/page";
import HirePythonDevelopersPage from "../pages/landing/hire-python-developers/page";
import HireNodejsDevelopersPage from "../pages/landing/hire-nodejs-developers/page";
import DedicatedDevelopmentTeamPage from "../pages/landing/dedicated-development-team/page";
import SaaSLandingPage from "../pages/landing/saas/page";
import FintechLandingPage from "../pages/landing/fintech/page";
import HealthtechLandingPage from "../pages/landing/healthtech/page";
import EcommerceLandingPage from "../pages/landing/ecommerce/page";
import LogisticsLandingPage from "../pages/landing/logistics/page";
import EdTechLandingPage from "../pages/landing/edtech/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/industries",
    element: <IndustriesPage />,
  },
  {
    path: "/technologies",
    element: <TechnologiesPage />,
  },
  {
    path: "/talent",
    element: <TalentPage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/case-studies",
    element: <CaseStudiesPage />,
  },
  {
    path: "/trust-security",
    element: <TrustSecurityPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/leadership",
    element: <LeadershipPage />,
  },
  {
    path: "/software-development",
    element: <SoftwareDevelopmentPage />,
  },
  {
    path: "/talent-solutions",
    element: <TalentSolutionsPage />,
  },
  {
    path: "/hire-react-developers",
    element: <HireReactDevelopersPage />,
  },
  {
    path: "/hire-python-developers",
    element: <HirePythonDevelopersPage />,
  },
  {
    path: "/hire-nodejs-developers",
    element: <HireNodejsDevelopersPage />,
  },
  {
    path: "/offshore-development-team-india",
    element: <OffshoreTeamIndiaPage />,
  },
  {
    path: "/dedicated-development-team",
    element: <DedicatedDevelopmentTeamPage />,
  },
  {
    path: "/industries/saas",
    element: <SaaSLandingPage />,
  },
  {
    path: "/industries/fintech",
    element: <FintechLandingPage />,
  },
  {
    path: "/industries/healthtech",
    element: <HealthtechLandingPage />,
  },
  {
    path: "/industries/ecommerce",
    element: <EcommerceLandingPage />,
  },
  {
    path: "/industries/logistics",
    element: <LogisticsLandingPage />,
  },
  {
    path: "/industries/edtech",
    element: <EdTechLandingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;